module.exports = {
	init: function ($) {
		this.isScrolling = false
		this.setupClickEvent($)
		this.menuClickEvent($)
		this.courseSidebarEvent($)
		this.handleResize($)
		window.addEventListener('scroll', this.handleScroll.bind(this, $))
		window.addEventListener('resize', this.handleResize)
	},
	setupClickEvent: function ($) {
		$(document).on('click', '.aside-container .anchor-item.link', function () {
			$('.aside-container .anchor-item').removeClass('selected').addClass('link')
			$(this).addClass('selected').removeClass('link')
			this.isScrolling = true
			$('html, body').animate(
				{
					scrollTop: $('#' + $(this).data('id')).offset().top - 100,
				},
				1000,
				() => {
					this.isScrolling = false
				},
			)
		})
	},
	menuClickEvent: function ($) {
		$(document).on('click', '.footer-menu__item', function () {
			if ($(this).data('menu') == 'open') {
				if ($(this).hasClass('active')) {
					$('body').removeClass('menu-open')
					$(this).removeClass('active')
				} else {
					$('body').addClass('menu-open')
					$(this).addClass('active')
					if ($(this).data('option') == 'search') {
						$('.search-form input').focus()
					}
				}
			}
			if ($(this).data('menu') == 'close') {
				$('body').removeClass('menu-open')
				$('.footer-menu__item').removeClass('active')
			}
		})
	},
	courseSidebarEvent: function ($) {
		$(document).on('click', '.course-sidebar__home', function (event) {
			if (window.innerWidth >= 1024) {
				return
			}

			event.preventDefault()

			const $sidebar = $(this).closest('.course-sidebar')

			$sidebar.toggleClass('is-open')
		})

		$(document).on('click', '.course-sidebar__category-button', function (event) {
			event.preventDefault()

			const $button = $(this)
			const $item = $button.closest('.course-sidebar__category')
			const $panel = $item.children('.course-sidebar__panel')
			const category = $button.attr('data-slug')

			if ($('body').hasClass('single-topics')) {
				if (category) {
					window.location.href = '/cursos/?category=' + encodeURIComponent(category)
				}

				return
			}

			if ($panel.length) {
				const isOpen = !$item.hasClass('is-open')

				$item.toggleClass('is-open', isOpen)
				$button.attr('aria-expanded', isOpen ? 'true' : 'false')
				$panel.prop('hidden', !isOpen)
			}

			if (!category || typeof xto_ajax === 'undefined') {
				return
			}

			$('.filter-item').removeClass('selected')
			$('.filter-item[data-slug="' + category + '"]')
				.addClass('selected')
				.removeClass('link')

			$('.loading').addClass('active')

			$.ajax({
				url: xto_ajax.ajax_url,
				type: 'post',
				data: {
					action: 'filter_categories',
					category: category,
				},
				success: function (response) {
					if (!response) {
						return
					}

					const result = JSON.parse(response)

					if (!result.status) {
						return
					}

					$('.grid-content').html(result.data.content)
					$('.breadcrumb').html(result.data.breadcrumb)
					$('.pagination').html(result.data.pagination)
					$('.main-container').removeClass('page-content')
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error('AJAX Error: ', textStatus, errorThrown)
				},
				complete: function () {
					$('.loading').removeClass('active')
				},
			})
		})

		$(document).on('click', '.course-sidebar__toggle', function (event) {
			event.preventDefault()
			event.stopPropagation()

			const $button = $(this)
			const $item = $button.closest('.course-sidebar__course')
			const $panel = $item.children('.course-sidebar__panel')
			const $toggle = $item.find('> .course-sidebar__course-header .course-sidebar__toggle')

			if (!$panel.length) {
				return
			}

			const isOpen = !$item.hasClass('is-open')

			$item.toggleClass('is-open', isOpen)
			$panel.prop('hidden', !isOpen)
			$toggle.attr('aria-expanded', isOpen ? 'true' : 'false')
		})
	},
	handleResize: function () {
		const windowWidth = window.innerWidth

		if (windowWidth < 1024) {
			jQuery('.aside-container details').removeAttr('open')
			jQuery('.course-sidebar').removeClass('is-open')
		} else {
			jQuery('.aside-container details').attr('open', true)
			jQuery('.course-sidebar').addClass('is-open')
		}
	},
	handleScroll: function ($) {
		if (this.isScrolling) {
			return
		}

		let scrollTop = $(window).scrollTop()
		let selectedItemId = null

		$('.single-cursos .course-section__item').each(function () {
			const offsetTop = $(this).offset().top
			const offsetBottom = offsetTop + $(this).outerHeight()

			if (scrollTop + 110 >= offsetTop && scrollTop < offsetBottom) {
				selectedItemId = $(this).attr('id')
			}
		})

		if (selectedItemId) {
			$('[data-id]').removeClass('selected').addClass('link')
			$('[data-id]')
				.filter('[data-id="' + selectedItemId + '"]')
				.addClass('selected')
				.removeClass('link')
		}
	},
}
